import { useEffect } from "react";

import { pushProduct } from "lib/gtm";

export default function GTMPushProductTag(product) {
  useEffect(() => {
    pushProduct(product);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
